import { OfferForm } from "components/forms";
import { useEffect } from "react";
import { useFormik } from "formik";
import { getDomain } from "router/filter";
import StepFooter from "./step-footer";
import {
    validationSchema,
    validationSchemaKEK,
} from "./validation";

type Props = {
    handleNext: (_values: any) => void;
    handlePrevious: () => void;
    handleCancel: () => void;
    initialValues: any;
    onFleetDetected?: (values: any) => void;
    isFirstStep?: boolean;
};

const OfferDetailsForm = ({
    handleCancel,
    handleNext,
    initialValues,
    handlePrevious,
    onFleetDetected,
    isFirstStep = true,
}: Props) => {
    const domain = getDomain();
    const form = useFormik<any>({
        initialValues,
        validationSchema:
            domain === "KEK" ? validationSchemaKEK : validationSchema,
        onSubmit: (values) => {
            handleNext(values);
        },
        onReset: () => {
            handleCancel();
        },
    });

    useEffect(() => {
        form.setValues(initialValues);
    }, [initialValues]);

    useEffect(() => {
        const businessName =
            form.values?.class_of_business_id?.business_name || "";
        if (businessName.includes("Fleet") && onFleetDetected) {
            onFleetDetected(form.values);
        }
    }, [form.values.class_of_business_id?.class_of_business_id]);

    const handleNextClick = async () => {
        const errors = await form.validateForm();
        form.setTouched(
            Object.keys(form.values).reduce(
                (acc, key) => ({ ...acc, [key]: true }),
                {},
            ),
        );
        if (Object.keys(errors).length > 0) {
            return;
        }
        handleNext(form.values);
    };

    return (
        <div className="flex-1 flex flex-col overflow-hidden">
            <form
                onSubmit={form.handleSubmit}
                className="space-y-6 divide-y divide-gray-200 overflow-y-auto flex-1">
                <div className="p-6">
                    <OfferForm form={form} />
                </div>
            </form>
            <StepFooter
                onNext={handleNextClick}
                onCancel={form.resetForm}
                onPrevious={handlePrevious}
                showPrevious={!isFirstStep}
            />
        </div>
    );
};

export default OfferDetailsForm;
